module.exports = __webpack_public_path__ + "img/arch3.ac90783e.svg";